module.exports = __webpack_public_path__ + "img/t1-19.0a44fdf9.png";